var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDownCaret = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.414,
    height: 8.121,
    viewBox: "0 0 13.414 8.121",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.707 0.707)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "downcaret",
    d: "M0,0,6,6l6-6",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: "2px"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDownCaret);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/down-caret.a457e9b27c9a731275a5d16b175f0809.svg";